import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { CounterCard } from "../../../components/Common/Common";

// css
import styles from "./Dashboard.module.scss";

// img
import "rc-pagination/assets/index.css";
import g1 from "../../../Assets/images/graph.png";
import g2 from "../../../Assets/images/pie.png";
import CustomPagination from "../../../components/Common/CustomPagination";
import Table from "../../../components/Common/Table";
import { BLOCK_UNBLOCK_CUSTOMER, GET_DASHBOARD_DATA } from "../../../services/ApiCalls";
import moment from "moment";
import { toast } from "react-toastify";
import Totalrevnue from "./revenuegraph";
import Salesanlytics from "./salesanlytics";
import TableProfile from "../../../components/Common/TableProfile";
import { Link } from "react-router-dom";
import LatestCustomers from "./LatestCustomers";
const Dashboard = () => {
  const [customerData, SetCustomerData] = useState([]);

  const [dashBoardData, setDashboardData] = useState();
  const getDashBoardData = async () => {
    const today = moment().format("DD-MM-YYYY");

    const tomorrow = moment().add(1, "days").format("DD-MM-YYYY");

    const dashboardRes = await GET_DASHBOARD_DATA({
      startDate: today,
      endDate: tomorrow,
    });

    if (dashboardRes?.data?.status === "success") {
      SetCustomerData(dashboardRes?.data?.data?.latestCustomers);
      setDashboardData(dashboardRes?.data?.data);
    } else {
      toast.error(dashboardRes?.data?.message);
    }
  };

  useEffect(() => {
    getDashBoardData();
  }, []);


  return (
    <>
      <section className="position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <CounterCard
                dashboardData={{
                  totalBookings: dashBoardData?.totalBookings,
                  totalCustomers: dashBoardData?.totalCustomers,
                  totalRevenue: dashBoardData?.lastWeekRevenue,
                }}
              />
            </Col>

            <Salesanlytics
              cancelBooking={dashBoardData?.statusCounts?.find(item => item.status === "Canceled")?.count || 0}
              ongoingBooking={dashBoardData?.statusCounts?.find(item => item.status === "Confirmed")?.count || 0}
              completeBooking={dashBoardData?.statusCounts?.find(item => item.status === "Completed")?.count || 0}
              upcomingBooking={dashBoardData?.statusCounts?.find(item => item.status === "Pending")?.count || 0}
              DashboardData={dashBoardData}
            />


            <Col lg="12" className="my-2">
              <LatestCustomers customerData={customerData} />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Dashboard;
